import s from './cancel-order.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { useCancelOrderModal } from '../../model/use-cancel-order-modal';
import { useCancelOrder } from '../../api/useCancelOrder';

export const CancelOrderModal = () => {
	const {isOpen, close, modalParams} = useCancelOrderModal()
	
	const orderId = modalParams?.orderId
	
	const { mutate: cancel } = useCancelOrder()
	
	const cancelAppointment = () => {
		cancel(orderId)
		close()
		modalParams?.onClose?.()
	}

  return (
		<Modal {...{isOpen, close}}>
			<div className={s.card}>
					<div className={s.title}>Вы уверены?</div>
					<div className={s.text}>Вы точно хотете отменить заявку?</div>
					<div className={s.btns}>
						<Button
							theme='secondary'
							className={s.btn}
							onClick={() => close()}
							label={'Нет'}
						/>
						<Button
							className={s.btn}
							onClick={cancelAppointment}
							label={'Да'}
						/>
					</div>
			</div>
		</Modal>
  );
};